<template>
	<div class="date">
		<label class="date__box">
			<span v-if="prevLabel" class="date__box__label--prev">{{
				prevLabel
			}}</span>
			<input
				:value="value"
				ref="input"
				:type="type"
				:min="parsedMin"
				:max="parsedMax"
				:disabled="disabled"
				class="date__box__input"
				@input="onInput"
				@keyup.enter="onEnter"
			/>
			<span v-if="nextLabel" class="date__box__label--next">{{
				nextLabel
			}}</span>
		</label>
	</div>
</template>
<script>
	export default {
		name: 'DateBox',
		props: {
			value: {
				type: String,
				default: '',
			},
			type: {
				// datetime-local, date, month
				type: String,
				default: 'datetime-local',
			},
			min: {
				type: String,
				default: '1970-01-02',
			},
			max: {
				type: String,
				default: '2038-01-18',
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			prevLabel: {
				type: String,
				default: '',
			},
			nextLabel: {
				type: String,
				default: '',
			},
		},
		computed: {
			parsedMin() {
				return this.type === 'date'
					? this.min
					: this.type === 'month'
						? this.min.slice(0, 7)
						: `${this.min}${'1970-01-02T00:00'.slice(this.min.length)}`;
			},
			parsedMax() {
				return this.type === 'date'
					? this.max
					: this.type === 'month'
						? this.max.slice(0, 7)
						: `${this.max}${'2038-01-18T23:59'.slice(this.max.length)}`;
			},
		},
		methods: {
			onInput(e) {
				this.$emit('input', e.target.value);
			},
			onEnter() {
				this.$emit('enter');
			},
			focus() {
				this.$refs.input.focus();
			},
		},
	};
</script>
<style lang="scss" scoped>
	DIV.date {
		.date__box {
			display: inline-flex;
			font-size: 0.875rem;
			font-weight: 400;
			align-items: center;
		}

		.date__box__label--prev {
			margin: 0 8px 0 0;
		}

		.date__box__label--next {
			margin: 0 0 0 8px;
		}

		.date__value {
			padding: 4px 0;
		}
	}
</style>
